define('datakit/mixin/url.root.template.mixin',['require','exports','module','underscore','backbone','../util/url'],function(require, exports, module) {
  var _ = require('underscore');
  var Backbone = require('backbone');
  var url = require('../util/url');

  var UrlRootTemplateMixin = {

    // many times you need to create an entity using a specificly formatted url
    urlRootTemplate: null,

    initializeMixin: function(attrs, options) {
      options = options || {};
      if (options.urlRootTemplate) {
        this.urlRootTemplate = options.urlRootTemplate;
      }
    },

    urlParams: function() {
      if (!this._urlParams) {
        this._urlParams = new Backbone.Model();
      }
      this._urlParams.set.apply(this._urlParams, arguments);
      return this;
    },

    clearUrlParams: function() {
      if (this._urlParams) {
        this._urlParams.clear();
      }
      return this;
    },

    urlRoot: function() {
      return url.template(this.urlRootTemplate, this._urlParams, this);
    },

    clearUrlRootTemplate: function() {
      delete this.urlRootTemplate;
      return this;
    },

    setUrlRootTemplate: function(urlRootTemplate) {
      this.urlRootTemplate = urlRootTemplate;
      return this;
    }

  };

  module.exports = UrlRootTemplateMixin;
});

